var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",style:({ backgroundImage: `url(${require('@/assets/torre-eiffel-pexels1.jpg')})`})})
}
var staticRenderFns = []

export { render, staticRenderFns }